import React from 'react'
import { Button, Stack, SxProps, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import { BannerProps } from './_props'
import sxs from './_sxs'
import { severityProps } from './severity'

export const Banner: React.FC<BannerProps> = ({
    title,
    text,
    icon,
    iconAlignment = 'center',
    severity = 'INFO',
    buttonProps,
    slotOverrides,
}) => {
    const variantSx = severityProps[severity] ?? {}

    const slots = Object.keys(variantSx.slots || {}).reduce(
        (acc, key) => {
            acc[key] = {
                ...(variantSx.slots as Record<string, SxProps>)[key],
                ...(slotOverrides?.[key] ?? {}),
            }
            return acc
        },
        {} as Record<string, SxProps>,
    )

    return (
        <Stack
            alignItems="stretch"
            justifyContent="space-between"
            flexDirection="row"
            gap="1rem"
            sx={{ ...sxs.banner, ...slots?.container }}
        >
            <Stack
                flexDirection="row"
                justifyContent={iconAlignment}
                alignItems="center"
                sx={{ ...sxs.bannerIconContainer, ...slots?.icon }}
            >
                {icon ?? <InfoIcon />}
            </Stack>
            <Stack
                justifyContent="center"
                alignItems="flex-start"
                flexGrow={1}
                sx={{ ...sxs.bannerContentContainer, ...slots?.content }}
            >
                <Typography sx={{ ...sxs.bannerTitle, ...slots?.title }}>{title}</Typography>
                <Typography sx={{ ...sxs.bannerText, ...slots?.text }}>{text}</Typography>
            </Stack>
            {buttonProps && (
                <Stack flexDirection="row" justifyContent="flex-end" flex={1}>
                    <Button {...buttonProps} sx={{ ...sxs.bannerButton, ...slots?.button }}>
                        {buttonProps.label}
                    </Button>
                </Stack>
            )}
        </Stack>
    )
}
